import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SkeletonModule } from 'primeng/skeleton';
import { MenuService } from '../../../services/menu.service';
import { ConfirmationService } from 'primeng/api';
import { PanelModule } from '../../../modules/panel.module';
import { BusinessListComponent } from '../../business/business-list/business-list.component';

@Component({
  selector: 'brt-menu-item-list',
  standalone: true,
  imports: [PanelModule, SkeletonModule, BusinessListComponent],
  providers: [ConfirmationService],
  templateUrl: './menu-item-list.component.html',
  styleUrl: './menu-item-list.component.scss'
})
export class MenuItemListComponent {
  basePath = this.route.snapshot.data['basePath'] || '/';
  @Input('menu-id') set menuId(value: string) {
    this.criteria.MenuId = value;
    this.load();
  }
  get menuId() { return this.criteria.MenuId; }
  menuItems: any[];
  total: number;
  loading: boolean = true;
  criteria: any = {};
  get isMainComponent() { return this.route.component == <any>this.constructor; }
  constructor(public router: Router, private route: ActivatedRoute, private menuService: MenuService, private confirmationService: ConfirmationService) {
    route.params.subscribe(async params => {
      this.criteria = { BusinessId: params['bid'], MenuId: params['mid'] };
    });
  }

  async load(event?: any) {
    if (!this.criteria.BusinessId) return;
    this.loading = true;

    if (event)
      this.criteria = {
        BusinessId: this.criteria.BusinessId,
        MenuId: this.criteria.MenuId,
        Query: this.criteria.Query?.trim() || null,
        From: event?.first || 0,
        Size: event?.rows || 10
      };

    var result = await this.menuService.searchMenuItem(this.criteria);
    this.menuItems = result.List;
    this.total = result.Total;
    this.menuItems.forEach(_ => {
      _._actions = [
        { label: 'Edit', icon: 'pi pi-fw pi-pencil', routerLink: [this.basePath, 'menu', this.criteria.BusinessId, this.criteria.MenuId || 'item', _.Id] },
        { separator: true },
        { label: 'Delete', icon: 'pi pi-fw pi-trash', command: () => this.deleteMenuItem(_) }
      ];
    });
    this.loading = false;
  }

  async deleteMenuItem(menuItem: any) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete this menu item?',
      accept: async () => {
        await this.menuService.deleteMenuItem(menuItem);
        await this.load();
      }
    });
  }

  async setOrder() {
    var indexes: { [id: string]: number } = {};
    for (var i = 0; i < this.menuItems.length; i++) {
      let index = this.criteria.From + i;
      if (this.menuItems[i].Order != index)
        indexes[this.menuItems[i].Id] = index;
    }
    await this.menuService.setMenuItemIndex(indexes);
  }

  private async saveMenuItem(menuItem: any, reload = false) {
    menuItem._loading = true;
    setTimeout(async () => {
      await this.menuService.saveMenuItem(menuItem);
      menuItem._loading = false;
      if (reload)
        await this.load();
    });
  }

  async toggleItemInMenu(menuItem: any) {
    var exists = menuItem.MenuIds?.includes(this.menuId);
    menuItem.MenuIds = menuItem.MenuIds?.filter(_ => _ != this.menuId) || [];
    if (!exists) menuItem.MenuIds.push(this.menuId);
    await this.saveMenuItem(menuItem);
  }

  async setNotAvaialbeUntil(menuItem: any, until?: Date) {
    menuItem.NotAvailableUntil = until;
    await this.saveMenuItem(menuItem);
  }

  filteredMenuItems: any[];
  async searchMenuItem(query: string) {
    this.filteredMenuItems = (await this.menuService.searchMenuItem({ Query: query?.trim() || null, BusinessId: this.criteria.BusinessId }))
      .List?.filter(_ => !_.MenuIds?.includes(this.menuId));
  }
  async addMenuItem(menuItem: any) {
    if (!this.menuId) return;
    menuItem.MenuIds = menuItem.MenuIds || [];
    menuItem.MenuIds.push(this.menuId);
    menuItem.Order = this.total;
    await this.saveMenuItem(menuItem, true);
  }
}
